// extracted by mini-css-extract-plugin
export var closeButton = "_ds-1";
export var closeX = "_ds-3";
export var container = "_ds-0";
export var image = "_ds-2";